import { useQuery } from "@tanstack/react-query";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import ApiService from "../../services/ApiService";
import { formatCurrency, formatNumber, formatPercentage } from "../../utils/formatUtils";
import { SPONSOR_PERFORMANCE_TABLE } from "../keys";

const useSponsorPerformanceTable = (sponsorObjectId) => {
  const tenant = useSelector((state) => state.auth.tenant);
  const date = useSelector((state) => state.date);
  const selectedCurrency = useSelector((state) => state.currency.selectedCurrency);

  const { startDate, endDate } = date;
  const enabled = !!(date.startDate && date.endDate);
  let since;
  let until;
  if (enabled) {
    since = format(date.startDate, "yyyy-MM-dd");
    until = format(date.endDate, "yyyy-MM-dd");
  }
  return useQuery({
    queryKey: [
      SPONSOR_PERFORMANCE_TABLE,
      sponsorObjectId,
      tenant.id,
      startDate,
      endDate,
    ],
    queryFn: () =>
      ApiService.getSponsorPerformanceTable(since, until, sponsorObjectId),
    select: (data) => {
      const rows = data.data.rows.map((row) => {
        // Only format if we have raw numeric data (not already formatted strings)
        const shouldFormat = typeof row.value === 'number' && typeof row.impressions === 'number';
        
        if (!shouldFormat) {
          // Return as-is if already formatted
          return row;
        }
        
        return {
          ...row,
          impressions: formatNumber(row.impressions, selectedCurrency, "0,0"),
          value: formatCurrency(row.value, selectedCurrency),
          roi: Number(row?.roi ?? 0)?.toFixed(2),
          percentage: row.percentage && formatPercentage(row.percentage, selectedCurrency, "0%"),
        };
      });
      data.data.rows = rows;
      return data.data;
    },
    placeholderData: { data: { headers: [], rows: [] } },
  });
};
export default useSponsorPerformanceTable;
